import { FileUploadInfo } from '@price-for-profit/micro-services';
import { useQueryClient, useMutation } from 'react-query';
import { useService } from 'shared/providers';

export function useUploadQuoteFiles() {
  const { quoteService } = useService();
  const queryClient = useQueryClient();
  const mutation = useMutation<FileUploadInfo[], Error, FormData>(request => quoteService.uploadQuoteFile(request), {
    onSuccess: () => {
      queryClient.invalidateQueries('files');
    },
    onError: error => {
      console.log('File not uploaded ', error);
    },
  });

  return mutation;
}
